export enum ServiceExtensions {
	LayoutRules = 'layout_rules'
}